import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingDots from 'src/assets/loading_dots.svg';

import {
	ORG_SETUP_NEEDS_SYNC,
	ORG_SETUP_SYNCING,
	ORG_SETUP_SYNC_ERROR,
} from 'src/utils/authOrg.constants';
import { INITIAL_IMPORT_TASK, JOB_WAITING, JOB_RUNNING } from 'src/utils/importJobs.constants';
import { anyWaiting, anyRunning, anyErrors, anyComplete } from 'src/utils/importJobs';

import { fetchImportJobs, requestCreateImportJob } from 'src/redux/importJobs/importJob.action';
import {
	getInitialImportJobs,
	getPendingImportJobs,
	getImportJobErrors,
} from 'src/redux/importJobs/importJob.selector';
import { getPendingAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import styles from '../index.css';

class StartSync extends Component {
	updateAuthOrgState = newSetupState => {
		this.setState({ waitingForTransition: true });
		this.props.requestUpdateAuthOrganization(this.props.authOrganizations[0]._id, {
			setup_state: newSetupState,
		});
	};

	constructor(props) {
		super(props);
		this.state = { waits: 0 };
	}

	componentDidMount(props) {
		this.props.fetchImportJobs({ initialImport: true });
		if (localStorage.syncRequestErrors) {
			delete localStorage.syncRequestErrors;
		}
	}

	componentWillUnmount(props) {
		if (this.state.fetchTimeoutId) {
			clearTimeout(this.state.fetchTimeoutId);
		}
	}

	async componentDidUpdate(prevProps) {
		// this will be undefined until+unless we create a job
		const createdJobId = this.state.createdJobId;

		// skip this if our props are missing, or we're mid-request,
		// or everything's done, or we're waiting intentionally
		if (
			!this.props.authOrganizations ||
			!this.props.pendingImportJobs ||
			!this.props.initialImportJobs ||
			this.props.pendingImportJobs.fetch ||
			this.props.pendingImportJobs.create ||
			this.props.pendingAuthOrganizations.update ||
			this.state.waitingToCheck ||
			this.state.waitingForTransition
		) {
			return;
		}

		// filter down to the created job OR any running/waiting initialImport jobs
		// this lets us know things like "if we have an error-state job, it's the one we created"
		const createdJobFilter = o => o._id === createdJobId;
		const runningOrWaitingFilter = o => o.status === JOB_RUNNING || o.status === JOB_WAITING;
		const jobs = this.props.initialImportJobs.filter(
			createdJobId ? createdJobFilter : runningOrWaitingFilter,
		);

		if (!jobs.length && !this.state.jobCreated) {
			// if there aren't running or waiting jobs,
			// and we didn't find/expect a created job,
			// ... create one!
			this.setState({ jobCreated: true });
			try {
				const debug = localStorage.hasOwnProperty('debugImportJobTask');
				const task = debug ? localStorage.debugImportJobTask : INITIAL_IMPORT_TASK;

				const newJobResult = await this.props.requestCreateImportJob({
					...(debug ? { debug, initialImport: true } : {}),
					task,
				});
				this.setState({ createdJobId: newJobResult.payload._id });
			} catch (error) {
				console.log('StartSync: error requesting job. Error: ', error);
				this.updateAuthOrgState(ORG_SETUP_SYNC_ERROR);
			}
		} else if (jobs.length > 1 || anyErrors(jobs)) {
			// if there is more than one job or the created job is in an error state:
			this.updateAuthOrgState(ORG_SETUP_SYNC_ERROR);
		} else if (anyRunning(jobs) || anyComplete(jobs)) {
			// if the created job is running or complete, or a pre-existing job is running:
			this.updateAuthOrgState(ORG_SETUP_SYNCING);
		} else if (anyWaiting(jobs) || (jobs.length === 0 && this.state.jobCreated)) {
			// if a pre-existing job is waiting,
			// or we don't have any jobs but we did request one

			const MAX_WAITS = 15;
			const WAIT_TIME_BETWEEN_FETCHES = 250; // 250 ms
			if (this.state.waits < MAX_WAITS) {
				// if we've only waited a few times at most, setup a timeout to check again soon
				const fetchTimeoutId = setTimeout(() => {
					this.props.fetchImportJobs({ initialImport: true });
					this.setState({ waitingToCheck: false, waits: this.state.waits + 1 });
				}, WAIT_TIME_BETWEEN_FETCHES);
				this.setState({ waitingToCheck: true, fetchTimeoutId });
			} else {
				// if we have gone through a wait cycle too many times,
				// write the error down for the sync error page and move on
				localStorage.syncRequestErrors = `error: waited ${MAX_WAITS} times for the job to start running`;
				this.updateAuthOrgState(ORG_SETUP_SYNC_ERROR);
			}
		} else {
			// the cases above should be exhaustive, so we may as well log this
			console.log('StartSync: unhandled case branch!');
		}
	}

	render() {
		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== ORG_SETUP_NEEDS_SYNC) {
			return <Redirect to={{ pathname: '/' }} />;
		}

		return <LoadingDots className={styles.SetupLoadingDots} />;
	}
}

const mapStateToProps = state => ({
	initialImportJobs: getInitialImportJobs(state),
	importJobErrors: getImportJobErrors(state),
	pendingImportJobs: getPendingImportJobs(state),
	pendingAuthOrganizations: getPendingAuthOrganizations(state),
});

const actions = {
	fetchImportJobs,
	requestCreateImportJob,
	requestUpdateAuthOrganization,
};

StartSync = connect(mapStateToProps, actions)(StartSync);

export default StartSync;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/StartSync/index.js